import { create } from 'zustand';
import { devtools, persist } from 'zustand/middleware';

const useGeneralStore = create(
  devtools(
    persist(
      (set) => ({
        // Navbar collapse state
        sidebarCollapsed: false,
        
        // Actions for navbar
        toggleSidebar: () => 
          set(
            (state) => ({ sidebarCollapsed: !state.sidebarCollapsed }),
            false,
            'toggle-sidebar'
          ),
        
        setSidebarCollapsed: (collapsed) =>
          set(
            { sidebarCollapsed: collapsed },
            false,
            'set-sidebar-collapsed'
          ),
      }),
      {
        name: 'general-storage',
        partialize: (state) => ({ sidebarCollapsed: state.sidebarCollapsed }), // Only persist sidebar state
      }
    ),
    {
      name: 'general-store', // Name for devtools
    }
  )
);

export default useGeneralStore; 